import { render, staticRenderFns } from "./UiChart.vue?vue&type=template&id=77c034a1&scoped=true"
import script from "./UiChart.vue?vue&type=script&lang=js"
export * from "./UiChart.vue?vue&type=script&lang=js"
import style0 from "./UiChart.vue?vue&type=style&index=0&id=77c034a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c034a1",
  null
  
)

export default component.exports